import { FormValidators } from 'utils/form/types';
import { isEmail, isPhone, isRequired, isShortZipCode } from 'utils/form/validators';
import EmailBaseFormStore from 'stores/common/EmailBaseFormStore';
import { EMAIL_SEND_BEST_RATE_REQUEST_FORM } from 'config/email/endpoints';

interface Form {
  zipCode: string;
  phone: string;
  email: string;
  agreeToReceive: 'yes' | 'no',
}

class CompareRatesStore extends EmailBaseFormStore<Form> {
  protected get endpoint(): string {
    return EMAIL_SEND_BEST_RATE_REQUEST_FORM;
  }

  protected getInitialForm(): Form {
    return {
      zipCode: '',
      phone: '',
      email: '',
      agreeToReceive: 'no',
    };
  }

  protected get validators(): FormValidators<Form> {
    return {
      zipCode: [isRequired(), isShortZipCode()],
      email: [isRequired(), isEmail()],
      phone: [isRequired(), isPhone()],
    };
  }
}

export default CompareRatesStore;
